module.exports = __webpack_public_path__ + "80d06e0bcf74b8d5d29716ddc30255c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/war_has_a_price-420.jpg
// module id = 620
// module chunks = 0